import { useMemo } from 'react';

export const useError = (
  condition: boolean,
  message: string
): string | null => {
  return useMemo<string | null>(() => {
    if (condition) {
      return message;
    }
    return null;
  }, [condition, message]);
};
